import { api } from './client';

export async function fetchRecentSolanaTransactions() {
  const { data } = await api.get('/v1/solana/transactions/recent');
  return data.transactions || [];
}
